module.exports = __webpack_public_path__ + "img/2-1.31c8a254.svg";